export var ProximaNova = 'Proxima Nova';